import classNames from "classnames";
import React, { useEffect, useState } from "react";
import { TIMING } from "../../constants/game";
import { GameQuestion } from "../../hooks/useGameQuestions";
import { GameState } from "../../types/game";
import styles from "./QuestionContainer.module.scss";
interface IQuestionContainerProps {
  question: GameQuestion | null;
  direction: "horizontal" | "vertical";
  gameState: GameState;
}

const VerticalText: React.FC<{
  text: string;
  direction: "horizontal" | "vertical";
}> = ({ text, direction }) => {
  if (direction === "horizontal") {
    return <div className={styles.horizontalText}>{text}</div>;
  }
  return (
    <div className={styles.verticalText}>
      {text
        .split("")
        .map((char, idx) =>
          char === " " ? (
            <div key={idx}>&nbsp;</div>
          ) : (
            <div key={idx}>{char}</div>
          )
        )}
    </div>
  );
};

const QuestionContainer: React.FC<IQuestionContainerProps> = ({
  question,
  direction,
  gameState,
}) => {
  const [timer, setTimer] = useState<number | undefined>(undefined);

  useEffect(() => {
    let interval: ReturnType<typeof setInterval> | undefined;
    if (gameState === GameState.START_DELAY) {
      setTimer(Math.floor(TIMING.GHOST_ENTRY_DELAY / 1000));
      interval = setInterval(() => {
        setTimer((prevTimer) => (prevTimer ? prevTimer - 1 : undefined));
      }, 1000);
    } else if (gameState === GameState.RESPAWN_DELAY) {
      setTimer(Math.floor(TIMING.GHOST_RESPAWN_DELAY / 1000) + 1);
      interval = setInterval(() => {
        setTimer((prevTimer) => (prevTimer ? prevTimer - 1 : undefined));
      }, 1000);
    }
    return () => {
      clearInterval(interval);
    };
  }, [gameState]);

  const getTimerText = (): string => {
    switch (gameState) {
      case GameState.END_DELAY:
        return "Game Over";
      case GameState.START_DELAY:
        return `Start in ${timer}`;
      case GameState.RESPAWN_DELAY:
        return `Respawn in ${timer}`;
      case GameState.PAUSED:
        return "Paused";
      default:
        return "";
    }
  };

  if (!question) return null;

  return (
    <div className={classNames(styles.container, styles[direction])}>
      {getTimerText() ? (
        <VerticalText text={getTimerText()} direction={direction} />
      ) : question.numbers.length > 0 ? (
        question.numbers.map((num, idx) => (
          <div key={idx} className={styles.number}>
            {idx > 0 && idx < question.numbers.length && num > 0 && (
              <span className={styles.operator}>{question.operator}</span>
            )}
            {num.toString()}
          </div>
        ))
      ) : null}
    </div>
  );
};

export default QuestionContainer;
